import React from "react";

const AssetPagination = ({ page, totalPages, total, onPageChange }) => {
  if (!total) return null;

  return (
    <div className="d-flex align-items-center justify-content-between my-3 flex-wrap gap-2">
      <span>
        Page {page} of {totalPages} ({total.toLocaleString()} assets)
      </span>
      <div className="btn-group" role="group" aria-label="Asset table pages">
        <button
          type="button"
          className="btn btn-outline-secondary"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
        >
          Previous
        </button>
        <button
          type="button"
          className="btn btn-outline-secondary"
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default AssetPagination;
